import { DaoService } from "./DaoService";

export class PrioriteService extends DaoService {
    static CLASS_NAME = 'App\\Models\\Priorite';


    static getInstance() {
        return super.getInstance('priorite');
    }

    enable(idOrUid) {
        return PrioriteService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    disable(idOrUid) {
        return PrioriteService.post(`${this.prefix}/${idOrUid}/disable`);
    }

    setDefault(idOrUid) {
        return PrioriteService.post(`${this.prefix}/${idOrUid}/set-default`);
    }

    all() {
        return PrioriteService.get(`${this.prefix}/all`);
    }

    search(data) {
        return PrioriteService.post(`${this.prefix}/search`, data);
    }
}